var cccApp = cccApp || {};

(function (app) {
    "use strict";

    app.enums = app.enums || {};

    app.enums.boostrapSizes = {
        "xs": {
            name: "xs",
            valueOf: function() {
                return 480;
            }
        },
        "sm": {
            name: "sm",
            valueOf: function() {
                return 768;
            }
        },
        "md": {
            name: "md",
            valueOf: function() {
                return 992;
            }
        },
        "lg": {
            name: "lg",
            valueOf: function() {
                return 1200;
            }
        }
    };

    app.enums.computerIcons = [
        { name: "Default", cssClass: "comp-sprite computer-image comp-ic--desktop middle", id: 0, order: 0 },
        { name: "Gaming", cssClass: "comp-sprite computer-image comp-ic--gaming", id: 1, order: 3 },
        { name: "Desktop", cssClass: "comp-sprite computer-image comp-ic--desktop", id: 2, order: 1 },
        { name: "Laptop", cssClass: "comp-sprite computer-image comp-ic--laptop", id: 3, order: 2 },
        { name: "Server", cssClass: "comp-sprite computer-image comp-ic--server", id: 4, order: 7 },
        { name: "Touchscreen PC", cssClass: "comp-sprite computer-image comp-ic--touch", id: 5, order: 5 },
        { name: "Touchscreen Laptop", cssClass: "comp-sprite computer-image comp-ic--touch-laptop", id: 6, order: 6 },
        { name: "Database Server", cssClass: "comp-sprite computer-image comp-ic--database", id: 7, order: 8 },
        { name: "Media", cssClass: "comp-sprite computer-image comp-ic--media", id: 8, order: 4 }
    ];

    app.enums.contactUsTypes = { "BugReport": 3, "Problem": 0, "Suggestion": 1, "Other": 2, "SalesEnquiry": 4 };

}(cccApp));